import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminMunicipalities_id = z.any()
export type TagsGetAdminMunicipalities_id = z.infer<typeof tagsGetAdminMunicipalities_id>

export const paramsGetAdminMunicipalities_id = z.object({ "id": z.string() })
export type ParamsGetAdminMunicipalities_id = z.infer<typeof paramsGetAdminMunicipalities_id>

export const responseGetAdminMunicipalities_id = z.object({ "payload": z.object({ "id": z.intersection(z.string(), z.string().max(191)), "name": z.intersection(z.string(), z.string().max(255)), "ico": z.intersection(z.string(), z.string().max(20)), "parseLimit": z.intersection(z.string(), z.string()), "address": z.string().optional(), "createdAt": z.intersection(z.string().datetime({ offset: true }), z.string()), "updatedAt": z.intersection(z.string().datetime({ offset: true }), z.string()), "user": z.object({ "id": z.string(), "email": z.string(), "name": z.string(), "verifiedEmail": z.boolean(), "verifiedByAdmin": z.boolean() }).optional(), "image": z.union([z.string().max(255), z.null()]), "plan": z.union([z.literal("TRIAL"), z.literal("STANDARD"), z.literal("VIP")]), "planStartedAt": z.string(), "planEndsAt": z.union([z.string(), z.null()]), "isSMSCrMember": z.union([z.boolean(), z.null()]), "smsCrServicesGDPRSale": z.boolean(), "deletedAt": z.union([z.string(), z.null()]), "collectionPoints": z.array(z.object({ "id": z.string(), "name": z.string(), "address": z.string().optional(), "type": z.string(), "customType": z.string().optional(), "customUnit": z.string().optional(), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }) })) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminMunicipalities_id = z.infer<typeof responseGetAdminMunicipalities_id>

interface IGetAdminMunicipalities_id extends BaseMethodType {
  tags: TagsGetAdminMunicipalities_id,
  params: ParamsGetAdminMunicipalities_id,
  response: ResponseGetAdminMunicipalities_id
}
export const tagsPatchAdminMunicipalities_id = z.any()
export type TagsPatchAdminMunicipalities_id = z.infer<typeof tagsPatchAdminMunicipalities_id>

export const paramsPatchAdminMunicipalities_id = z.object({ "id": z.string() })
export type ParamsPatchAdminMunicipalities_id = z.infer<typeof paramsPatchAdminMunicipalities_id>

export const bodyPatchAdminMunicipalities_id = z.object({ "parseLimit": z.number().gte(0).optional(), "plan": z.enum(["VIP","TRIAL"]).optional(), "planEndsAt": z.string().datetime({ offset: true }).optional() })
export type BodyPatchAdminMunicipalities_id = z.infer<typeof bodyPatchAdminMunicipalities_id>

export const responsePatchAdminMunicipalities_id = z.object({ "payload": z.object({ "id": z.string(), "name": z.string(), "ico": z.string(), "parseLimit": z.string().optional(), "address": z.string().optional(), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }), "user": z.object({ "id": z.string(), "email": z.string(), "name": z.string(), "verifiedEmail": z.boolean(), "verifiedByAdmin": z.boolean() }).optional() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePatchAdminMunicipalities_id = z.infer<typeof responsePatchAdminMunicipalities_id>

interface IPatchAdminMunicipalities_id extends BaseMethodType {
  tags: TagsPatchAdminMunicipalities_id,
  params: ParamsPatchAdminMunicipalities_id,
  body: BodyPatchAdminMunicipalities_id,
  response: ResponsePatchAdminMunicipalities_id
}
export const URL = '/admin/municipalities/:id'
export const validation = {
  get: {
    tags: tagsGetAdminMunicipalities_id,
    params: paramsGetAdminMunicipalities_id,
    response: responseGetAdminMunicipalities_id
  },
  patch: {
    tags: tagsPatchAdminMunicipalities_id,
    params: paramsPatchAdminMunicipalities_id,
    body: bodyPatchAdminMunicipalities_id,
    response: responsePatchAdminMunicipalities_id
  }
}
export interface AdminMunicipalities_id extends BaseRouteType {
  get: IGetAdminMunicipalities_id,
  patch: IPatchAdminMunicipalities_id
}